export enum ChartMarkers {
  NONE = 'NO MARKER',
  COLOR = 'COLOR',
  SHAPE = 'SHAPE',
  LINE_TYPE = 'LINE TYPE',
  THICKNESS = 'THICKNESS'
}
